'use client';

import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { subscribeUpgradeRequired, type LimitInfo } from '@/lib/upgradeRequired';

const LIMIT_LABELS: Record<string, string> = {
  bank_connections: 'conexões bancárias',
  goals: 'metas',
  active_budgets: 'orçamentos ativos',
  ai_messages: 'mensagens de IA',
};

export function UpgradeRequiredDialog() {
  const [info, setInfo] = useState<LimitInfo | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeUpgradeRequired(setInfo);
    return () => {
      unsubscribe();
    };
  }, []);

  const open = info !== null;
  const label = info ? LIMIT_LABELS[info.limit] ?? info.limit : '';

  return (
    <Dialog open={open} onOpenChange={(v) => !v && setInfo(null)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Limite do plano atingido</DialogTitle>
          <DialogDescription>
            {info && (
              <>
                Seu plano atual permite até <strong>{info.max}</strong> {label}. Faça upgrade para liberar mais.
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => setInfo(null)}>
            Agora não
          </Button>
          <Button
            onClick={() => {
              const url = info?.upgradeUrl ?? '/profile';
              setInfo(null);
              window.location.assign(url);
            }}
          >
            Ver planos
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
